function getFullName(profile, shortened = false) {
  if (!profile) return ''
  if (shortened) {
    return `${profile.firstName || ''} ${
      profile.lastName ? profile.lastName.at(0) : ''
    }.`
  }

  return `${profile.firstName || ''} ${profile.lastName || ''}`
}

export default getFullName
